import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router';

import { ADMIN_ROUTE_PATH, ADMIN_ROUTE_RELATIVE_PATH } from '@/administration/constants/adminRoutePaths';
import { useLearningJourneyBreadcrumbs } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';
import { ROUTE_PATH } from '@/constants/routePaths';

type UseIsInJourneyContextOptions = {
  includeLearner?: boolean;
  includeAdmin?: boolean;
};

const LEARNER_JOURNEY_PATH = ROUTE_PATH.JOURNEY_MATCH;
const ADMIN_JOURNEY_PATH = `${ADMIN_ROUTE_PATH.JOURNEYS}/${ADMIN_ROUTE_RELATIVE_PATH.JOURNEY}`;
const LEARNING_CONTENT_PATH = ROUTE_PATH.LEARNING_MATCH;
const PRODUCT_CONTENT_PATH = ROUTE_PATH.COURSE_DETAILS_MATCH;

export const useIsInJourneyContext = (options?: UseIsInJourneyContextOptions): boolean => {
  const { includeLearner = true, includeAdmin = true } = options || {};
  const location = useLocation();

  const pathname = location.pathname;

  const learningMatch = matchPath({ path: LEARNING_CONTENT_PATH, end: false }, pathname);
  const productMatch = matchPath({ path: PRODUCT_CONTENT_PATH, end: false }, pathname);

  const learningId = learningMatch?.params?.id ? parseInt(learningMatch.params.id, 10) : NaN;
  const productId = productMatch?.params?.id ? parseInt(productMatch.params.id, 10) : NaN;

  const learningParentJourney = useLearningJourneyBreadcrumbs({
    id: learningId || 0,
    isProduct: false,
  });

  const productParentJourney = useLearningJourneyBreadcrumbs({
    id: productId || 0,
    isProduct: true,
  });

  if (includeLearner) {
    const learnerMatch = matchPath({ path: LEARNER_JOURNEY_PATH, end: false }, pathname);
    if (learnerMatch) return true;

    // Learning/product content that's part of a journey with user participation
    if (learningParentJourney?.journeyId || productParentJourney?.journeyId) return true;
  }

  if (includeAdmin) {
    const adminMatch = matchPath({ path: ADMIN_JOURNEY_PATH, end: false }, pathname);
    if (adminMatch) return true;
  }

  return false;
};
